import { type WrappedInsightEveningAllStarAttributes } from "@clipboard-health/contract-backend-main";
import { Image, Span, Text } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";

import cloudsIcon from "../../assets/clouds-wrapped.png";

interface EveningAllStarContentProps {
  attributes: WrappedInsightEveningAllStarAttributes;
}

export function EveningAllStarContent(props: EveningAllStarContentProps) {
  const { attributes } = props;

  return (
    <Stack flex={1} position="relative">
      {/* Text section - top left */}
      <Stack
        position="absolute"
        sx={{
          top: "12%",
          left: "7.7%",
        }}
        gap={1}
      >
        <Text variant="body1" color="white">
          You are an
        </Text>
        <Text variant="h1" color="white" sx={{ fontSize: "3.5rem", lineHeight: 1 }}>
          Evening
        </Text>
        <Text variant="h1" color="white" sx={{ fontSize: "3.5rem", lineHeight: 1 }}>
          All-Star
        </Text>
        <Text variant="body2" sx={{ marginTop: 2 }}>
          <Span sx={{ color: "rgba(255, 255, 255, 0.6)" }}>{attributes.amShifts} AM Shifts · </Span>
          <Span sx={{ fontWeight: 500, color: "white" }}>{attributes.pmShifts} PM Shifts</Span>
          <Span sx={{ color: "rgba(255, 255, 255, 0.6)" }}>
            {" "}
            · {attributes.nocShifts} NOC Shifts
          </Span>
        </Text>
      </Stack>

      {/* Clouds image - positioned at bottom */}
      <Box
        position="absolute"
        sx={{
          bottom: 0,
          left: "-20%",
          right: 0,
        }}
      >
        <Image src={cloudsIcon} alt="Clouds" width="100%" height="auto" />
      </Box>
    </Stack>
  );
}
